import { request } from "./http";

// Configurações de envio automático via WhatsApp para a empresa

export const getCompanyWhatsappSettings = () =>
  request<
    | {
        type: "daily" | "before" | "none";
        time?: string | null;
        hours_before?: number | null;
        instance_id?: string | null;
      }
    | null
  >("/api/company/whatsapp");

export const updateCompanyWhatsappSettings = (body: {
  type: "daily" | "before" | "none";
  time?: string | null;
  hours_before?: number | null;
  instance_id?: string | null;
}) =>
  request<{
    type: "daily" | "before" | "none";
    time?: string | null;
    hours_before?: number | null;
    instance_id?: string | null;
  }>("/api/company/whatsapp", {
    method: "PUT",
    body: JSON.stringify(body),
  });

// Dispara a conexão do WhatsApp e retorna os dados do QR Code
export const getWhatsappQrCode = (instanceName: string) =>
  request<any>("/api/whatsapp/connect", {
    method: "POST",
    body: JSON.stringify({ instance_name: instanceName }),
  });

export const getWhatsappState = (instanceName: string) =>
  request<{ instance?: { instanceName?: string; state?: string } }>(
    `/api/whatsapp/state?instance_name=${encodeURIComponent(instanceName)}`
  );
